import { Base } from 'layouts'
import { ClientGroupForm } from 'components'

import * as S from './styled'

export function ClientGroupRegister() {
  return (
    <Base>
      <S.GridContainer container>
        <ClientGroupForm />
      </S.GridContainer>
    </Base>
  )
}
